<template>
  <div class="marker--staticrider">
    <div class="marker__tips--staticrider" :class="{'marker__tips--active': active}">{{name}} 
      <span v-if="unfinishNum !== undefined"><span class="marker__tips__key">{{unfinishNum}}</span>单</span>
      <span v-if="distance"><span class="marker__tips__key">{{distance.toFixed(2)}}</span>km</span>
    </div>
    <div class="marker__image--staticrider"></div>
  </div>
</template>

<script>
export default {
  name: 'StaticRiderMarker',
  props: ['name', 'unfinishNum', 'distance', 'active'],
};
</script>

<style lang="less">
.marker--staticrider {
  position: absolute;
  left: -10px;
  top: -65px;
  color: #666;
  .marker__tips--staticrider {
    background: #fff;
    padding: 8px 10px;
    white-space: nowrap;
    box-shadow: 0 4px 10px 0 rgba(0,0,0,0.10);
    border-radius: 5px;
    position: relative;
    margin-bottom: 5px;
    &:after {
      content: '';
      position: absolute;
      display: block;
      width: 10px;
      height: 10px;
      background: #fff;
      transform: rotate(45deg);
    }
    .marker__tips__key {
      color: #009AFF;
    }
  }
  .marker__image--staticrider {
    width: 35px;
    height: 35px;
    background: url('../../../static/images/kfc-rider.png');
    background-repeat: no-repeat;
    background-size: 35px 35px;
    position: relative;
  }
  .marker__tips--active {
    animation: active 5s;
  }
}
@keyframes active
{
  0% {box-shadow: none}
  25% {box-shadow: 0px 0px 20px #ff4d62}
  50% {box-shadow: none}
  90% {box-shadow: 0px 0px 10px #ff4d62}
  100% {box-shadow: none}
}
</style>




// WEBPACK FOOTER //
// src/components/AMap/StaticRiderMarker.vue